"use client";

import { c as _c } from "react/compiler-runtime";
import { type FocusEvent, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import GroupCreateIdentitiesSearchItems, { type GroupCreateIdentitiesSearchResultsLayout } from "./GroupCreateIdentitiesSearchItems";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
export default function GroupCreateIdentitiesSearch(t0) {
  const $ = _c(31);
  const {
    selectedWallets,
    onIdentitySelect,
    placeholder: t1,
    label: t2,
    hideLabel: t3,
    inputClassName: t4,
    iconClassName: t5,
    resultsLayout: t6
  } = t0;
  const placeholder = t1 === undefined ? " " : t1;
  const label = t2 === undefined ? "Identity" : t2;
  const hideLabel = t3 === undefined ? false : t3;
  const inputClassName = t4 === undefined ? "" : t4;
  const iconClassName = t5 === undefined ? "" : t5;
  const resultsLayout = t6 === undefined ? "popover" : t6;
  const [isOpen, setIsOpen] = useState(false);
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = newV => {
      if (newV) {
        setIsOpen(true);
      }
    };
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  const onFocusChange = t7;
  const [searchCriteria, setSearchCriteria] = useState(null);
  let t8;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = newV_0 => {
      setSearchCriteria(newV_0);
    };
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const onSearchCriteriaChange = t8;
  const wrapperRef = useRef(null);
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsOpen(false);
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  useClickAway(wrapperRef, t9);
  let t10;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  useKeyPressEvent("Escape", t10);
  let t11;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event => {
      const nextTarget = event.relatedTarget as Node | null;
      if (nextTarget && wrapperRef.current?.contains(nextTarget)) {
        return;
      }
      setIsOpen(false);
    };
    $[4] = t11;
  } else {
    t11 = $[4];
  }
  const onWrapperBlur = t11;
  let t12;
  if ($[5] !== onIdentitySelect) {
    t12 = item => {
      onIdentitySelect(item);
      setIsOpen(false);
      setSearchCriteria(null);
    };
    $[5] = onIdentitySelect;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  const onSelect = t12;
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = getRandomObjectId();
    $[7] = t13;
  } else {
    t13 = $[7];
  }
  const randomId = t13;
  const t14 = searchCriteria ?? "";
  let t15;
  let t16;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e => onSearchCriteriaChange(e.target.value);
    t16 = () => onFocusChange(true);
    $[8] = t15;
    $[9] = t16;
  } else {
    t15 = $[8];
    t16 = $[9];
  }
  const t17 = `tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-700 tw-bg-iron-950 tw-pb-3 tw-pl-10 tw-pr-4 tw-pt-3 tw-text-base tw-font-medium tw-text-white tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 hover:tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-text-sm ${inputClassName}`;
  let t18;
  if ($[10] !== placeholder || $[11] !== t14 || $[12] !== t17) {
    t18 = <input type="text" value={t14} onChange={t15} onFocus={t16} id={randomId} className={t17} placeholder={placeholder} />;
    $[10] = placeholder;
    $[11] = t14;
    $[12] = t17;
    $[13] = t18;
  } else {
    t18 = $[13];
  }
  const t19 = `tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-300 ${iconClassName}`;
  let t20;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />;
    $[14] = t20;
  } else {
    t20 = $[14];
  }
  let t21;
  if ($[15] !== t19) {
    t21 = <svg className={t19} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">{t20}</svg>;
    $[15] = t19;
    $[16] = t21;
  } else {
    t21 = $[16];
  }
  const t22 = `tw-absolute tw-start-1 tw-top-2 tw-z-10 tw-ml-7 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-rounded-lg tw-bg-iron-900 tw-px-2 tw-text-md tw-font-medium tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4 ${hideLabel ? "tw-sr-only" : ""}`;
  let t23;
  if ($[17] !== label || $[18] !== t22) {
    t23 = <label htmlFor={randomId} className={t22}>{label}</label>;
    $[17] = label;
    $[18] = t22;
    $[19] = t23;
  } else {
    t23 = $[19];
  }
  let t24;
  if ($[20] !== isOpen || $[21] !== onSelect || $[22] !== resultsLayout || $[23] !== searchCriteria || $[24] !== selectedWallets) {
    t24 = <GroupCreateIdentitiesSearchItems open={isOpen} searchCriteria={searchCriteria} onSelect={onSelect} selectedWallets={selectedWallets} resultsLayout={resultsLayout} />;
    $[20] = isOpen;
    $[21] = onSelect;
    $[22] = resultsLayout;
    $[23] = searchCriteria;
    $[24] = selectedWallets;
    $[25] = t24;
  } else {
    t24 = $[25];
  }
  let t25;
  if ($[26] !== t18 || $[27] !== t21 || $[28] !== t23 || $[29] !== t24) {
    t25 = <div className="tw-group tw-relative tw-w-full" ref={wrapperRef} onBlur={onWrapperBlur}>{t18}{t21}{t23}{t24}</div>;
    $[26] = t18;
    $[27] = t21;
    $[28] = t23;
    $[29] = t24;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  return t25;
}